import request from '@/utils/request'

// 获取课程的教学计划列表
export function getTeachingPlans(courseId) {
  return request({
    url: `/teaching-plan/course/${courseId}`,
    method: 'get'
  })
}

// 创建教学计划
export function createTeachingPlan(data) {
  return request({
    url: '/teaching-plan',
    method: 'post',
    data
  })
}

// 更新教学计划
export function updateTeachingPlan(id, data) {
  return request({
    url: `/teaching-plan/${id}`,
    method: 'put',
    data
  })
}

// 删除教学计划
export function deleteTeachingPlan(id) {
  return request({
    url: `/teaching-plan/${id}`,
    method: 'delete'
  })
}

// 获取教学计划的活动列表
export function getActivitiesByPlan(planId) {
  return request({
    url: `/teaching-plan/${planId}/activities`,
    method: 'get'
  })
}

// 创建教学活动
export function createActivity(data) {
  return request({
    url: '/teaching-plan/activity',
    method: 'post',
    data
  })
}

// 更新教学活动
export function updateActivity(id, data) {
  return request({
    url: `/teaching-plan/activity/${id}`,
    method: 'put',
    data
  })
}

// 删除教学活动
export function deleteActivity(id) {
  return request({
    url: `/teaching-plan/activity/${id}`,
    method: 'delete'
  })
}

// 获取课程的资源列表
export function getResourcesByCourse(courseId) {
  return request({
    url: `/course-resource/list/${courseId}`,
    method: 'get'
  })
}

// 获取课程的作业列表
export function getHomeworksByCourse(courseId) {
  return request({
    url: `/homework/course/${courseId}`,
    method: 'get'
  })
}

// 获取课程的考试列表
export function getExamsByCourse(courseId) {
  return request({
    url: `/exam/course/${courseId}`,
    method: 'get'
  })
}

// 获取学生在课程中的活动完成状态
export function getStudentActivityStatus(studentId, courseId) {
  return request({
    url: `/teaching-plan/student/${studentId}/course/${courseId}/status`,
    method: 'get'
  })
}
